/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBuy = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0 2c-4.412 0-8 3.59-8 8s3.588 8 8 8 8-3.59 8-8-3.588-8-8-8zm1 2-.001 1H16v2h-3.001v2H14c1.654 0 3 1.346 3 3s-1.346 3-3 3h-1.001v1h-2v-1H8v-2h2.999v-2H10c-1.654 0-3-1.346-3-3s1.346-3 3-3h.999V6zm1 7h-1.001v2H14a1.001 1.001 0 0 0 0-2zm-3.001-4H10a1.001 1.001 0 0 0 0 2h.999z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBuy as Buy };
